// Import mutations
import { SET_VERSION } from './mutation-types.js';

const resource = '/version.json';

// Initial state
const state = () => ({ version: {} });

// Actions
const actions = {
    /**
     * Get the version from the JSON file.
     */
    getVersionFromJson: () => {
        return fetch(`${resource}?t=${Date.now()}`)
            .then(response => response.json())
            .then(({ version }) => version);
    },

    /**
     * Get the version from the JSON file and set it in the state.
     */
    setVersionFromJson: (context) => {
        return fetch(`${resource}?t=${Date.now()}`)
            .then(response => response.json())
            .then(({ version }) => {
                context.commit(SET_VERSION, version);
                return version;
            });
    }
};

// Mutations
const mutations = {
    [SET_VERSION]: (state, payload) => {
        state.version = payload;
    }
};

// Export module
export default {
    namespaced: true,
    state,
    actions,
    mutations
};
